import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { submitInquiry } from '../services/api';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg(null);

    try {
      const result = await submitInquiry(formData);
      setResponseMsg({ type: 'success', text: result.message });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      setResponseMsg({
        type: 'error',
        text: error.response?.data?.message || 'Something went wrong. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      {/* Page Title */}
      <div 
        className="tf-page-title mt-10" 
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          padding: '80px 0'
        }}
      >
        <div className="themesflat-container full">
          <div className="page-title t-al-center">
            <span style={{ color: '#edb808', fontSize: '14px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase' }}>
              Get In Touch
            </span>
            <h1 className="main-title" style={{ color: 'white', fontSize: '48px', fontWeight: '700', marginTop: '10px' }}>
              Contact Cab Experience
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', marginTop: '15px', maxWidth: '600px', margin: '15px auto 0' }}>
              Have questions about our rental services? We're here to help you plan your perfect journey.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Info Cards */}
      <section style={{ padding: '60px 0', marginTop: '-50px', position: 'relative', zIndex: '10' }}>
        <div className="themesflat-container">
          <div className="row" style={{ justifyContent: 'center' }}>
            {/* Phone Card */}
            <div className="col-lg-4 col-md-6 mb-30" style={{ maxWidth: '400px' }}>
              <div className="contact-info-card" style={{
                background: 'white',
                padding: '40px 30px',
                borderRadius: '16px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                height: '100%'
              }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a2e', marginBottom: '10px' }}>
                  Phone Number
                </h3>
                <p style={{ color: '#666', fontSize: '15px', marginBottom: '15px' }}>
                  Available 24/7 for your convenience
                </p>
                <a href="tel:+917801904444" style={{ 
                  color: '#edb808', 
                  fontSize: '18px', 
                  fontWeight: '600',
                  textDecoration: 'none' 
                }}>
                  +91 7801904444
                </a>
              </div>
            </div>

            {/* Email Card */}
            <div className="col-lg-4 col-md-6 mb-30" style={{ maxWidth: '400px' }}>
              <div className="contact-info-card" style={{
                background: 'white',
                padding: '40px 30px',
                borderRadius: '16px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                height: '100%'
              }}>
              
                <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a2e', marginBottom: '10px' }}>
                  Email Address
                </h3>
                <p style={{ color: '#666', fontSize: '15px', marginBottom: '15px' }}>
                  We'll respond within 24 hours
                </p>
                <a href="mailto:info@cabexperience.com" style={{ 
                  color: '#edb808', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  textDecoration: 'none',
                  wordBreak: 'break-all'
                }}>
                  info@cabexperience.com
                </a>
              </div>
            </div>

            {/* Address Card */}
            <div className="col-lg-4 col-md-6 mb-30" style={{ maxWidth: '400px' }}>
              <div className="contact-info-card" style={{
                background: 'white',
                padding: '40px 30px',
                borderRadius: '16px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                height: '100%'
              }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a2e', marginBottom: '10px' }}>
                  Our Location
                </h3>
                <p style={{ color: '#666', fontSize: '15px', marginBottom: '15px' }}>
                  Visit our office
                </p>
                <p style={{ 
                  color: '#1a1a2e', 
                  fontSize: '15px', 
                  fontWeight: '500',
                  lineHeight: '1.6'
                }}>
                   Cab Experience, KKV Chowk Opp. St. Mary's Public School Kalawad Rd, Near KKV Hall, Rajkot, Gujarat, India
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section style={{ padding: '60px 0', background: '#f8f9fa' }}>
        <div className="themesflat-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12">
              {/* Section Title */}
              <div className="text-center mb-50">
                <span style={{ 
                  color: '#edb808', 
                  fontSize: '14px', 
                  fontWeight: '600', 
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  display: 'block',
                  marginBottom: '10px'
                }}>
                  Send Us a Message
                </span>
                <h2 style={{ 
                  fontSize: '36px', 
                  fontWeight: '700', 
                  color: '#1a1a2e',
                  marginBottom: '15px'
                }}>
                  We'd Love to Hear From You
                </h2>
                <p style={{ 
                  color: '#666', 
                  fontSize: '16px',
                  maxWidth: '600px',
                  margin: '0 auto',
                  lineHeight: '1.7'
                }}>
                  Have a question about our rental services or need help planning your trip? 
                  Fill out the form below and our team will get back to you shortly.
                </p>
              </div>

              {/* Contact Form */}
              <div className="contact-form-wrapper" style={{
                background: 'white',
                padding: '50px',
                borderRadius: '20px',
                boxShadow: '0 15px 50px rgba(0,0,0,0.08)'
              }}>
               

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Name Field */}
                    <div className="col-lg-6 col-md-6 mb-25">
                      <div className="form-group">
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#1a1a2e',
                          fontSize: '14px'
                        }}>
                          Your Name *
                        </label>
                        <div style={{ position: 'relative' }}>
                          <input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter your name"
                            type="text"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 15px 15px 50px',
                              border: '2px solid #e8e8e8',
                              borderRadius: '10px',
                              fontSize: '15px',
                              transition: 'all 0.3s ease',
                              background: '#f8f9fa'
                            }}
                          />
                          <span style={{
                            position: 'absolute',
                            left: '18px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#999'
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5"/>
                              <path d="M10 12C14.4183 12 18 13.7909 18 15V17H2V15C2 13.7909 5.58172 12 10 12Z" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Email Field */}
                    <div className="col-lg-6 col-md-6 mb-25">
                      <div className="form-group">
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#1a1a2e',
                          fontSize: '14px'
                        }}>
                          Email Address *
                        </label>
                        <div style={{ position: 'relative' }}>
                          <input
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            type="email"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 15px 15px 50px',
                              border: '2px solid #e8e8e8',
                              borderRadius: '10px',
                              fontSize: '15px',
                              transition: 'all 0.3s ease',
                              background: '#f8f9fa'
                            }}
                          />
                          <span style={{
                            position: 'absolute',
                            left: '18px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#999'
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.5 6.25L8.125 10.2083C9.16667 11.0417 10.8333 11.0417 11.875 10.2083L17.5 6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <rect x="2.5" y="4" width="15" height="12.5" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Phone Field */}
                    <div className="col-lg-6 col-md-6 mb-25">
                      <div className="form-group">
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#1a1a2e',
                          fontSize: '14px'
                        }}>
                          Phone Number *
                        </label>
                        <div style={{ position: 'relative' }}>
                          <input
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Enter your phone number"
                            type="tel"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 15px 15px 50px',
                              border: '2px solid #e8e8e8',
                              borderRadius: '10px',
                              fontSize: '15px',
                              transition: 'all 0.3s ease',
                              background: '#f8f9fa'
                            }}
                          />
                          <span style={{
                            position: 'absolute',
                            left: '18px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#999'
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.06667 4L5.66667 5.4C4.73333 4.6 4.53333 4.06667 4.66667 3.6C4.8 3.13333 5.66667 2.26667 6.33333 2.6L8.06667 3.13333C8.6 2.86667 9.4 2.86667 10 3.13333L10.1333 3.26667C10.6667 3.8 10.6667 5.4 10 6.33333L8.66667 7.33333C8.66667 7.33333 8.66667 8 9.13333 8.66667C9.6 9.33333 10.6667 10.6667 12 12C13.3333 13.3333 14.6667 14.4 15.3333 14.8667C16 15.3333 16.6667 15.3333 16.6667 15.3333L17.6667 14C18.6 13.0667 18.6 12.2667 18.8667 11.7333L18.6667 10H18.6667C17.8 9.33333 17.0667 8.6 16.4 7.93333C16.1333 7.66667 15.8667 7.66667 15.6 7.66667H14.6667C14.6667 7 14.6667 6.2 14.2667 5.6L12.6 3.93333C12.2667 3.6 11.5333 3.6 11.0667 4L9.66667 4.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Subject Field */}
                    <div className="col-lg-6 col-md-6 mb-25">
                      <div className="form-group">
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#1a1a2e',
                          fontSize: '14px'
                        }}>
                          Subject *
                        </label>
                        <div style={{ position: 'relative' }}>
                          <input
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Enter subject"
                            type="text"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 15px 15px 50px',
                              border: '2px solid #e8e8e8',
                              borderRadius: '10px',
                              fontSize: '15px',
                              transition: 'all 0.3s ease',
                              background: '#f8f9fa'
                            }}
                          />
                          <span style={{
                            position: 'absolute',
                            left: '18px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#999'
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.33333 3.33333H16.6667C17.0833 3.33333 17.5 3.41667 17.9167 3.58333L10 11.25L2.08333 3.58333C2.5 3.41667 2.91667 3.33333 3.33333 3.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                              <path d="M2.08333 7.5L10 15.4167L17.9167 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Message Field */}
                    <div className="col-lg-12 mb-30">
                      <div className="form-group">
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontWeight: '500',
                          color: '#1a1a2e',
                          fontSize: '14px'
                        }}>
                          Your Message *
                        </label>
                        <div style={{ position: 'relative' }}>
                          <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Enter your message"
                            rows="5"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 15px 15px 50px',
                              border: '2px solid #e8e8e8',
                              borderRadius: '10px',
                              fontSize: '15px',
                              transition: 'all 0.3s ease',
                              background: '#f8f9fa',
                              resize: 'vertical',
                              fontFamily: 'inherit'
                            }}
                          ></textarea>
                          <span style={{
                            position: 'absolute',
                            left: '18px',
                            top: '20px',
                            color: '#999'
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.5 4.16667H17.5C17.9167 4.16667 18.3333 4.25 18.75 4.41667L10 13.3333L1.25 4.41667C1.66667 4.25 2.08333 4.16667 2.5 4.16667Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-lg-12 text-center">
                      <button
                        type="submit"
                        disabled={loading}
                        style={{
                          padding: '18px 50px',
                          background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                          color: '#1a1a2e',
                          border: 'none',
                          borderRadius: '50px',
                          fontSize: '16px',
                          fontWeight: '600',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          opacity: loading ? 0.7 : 1,
                          transition: 'all 0.3s ease',
                          boxShadow: '0 8px 25px rgba(237, 184, 8, 0.3)',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '10px'
                        }}
                      >
                        {loading ? (
                          <>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'spin 1s linear infinite' }}>
                              <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
                              <path d="M10 0V5M10 15V20M15 10H20M5 10H0M3.5 3.5L7 7M13 13L16.5 16.5M3.5 16.5L7 13M13 7L16.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            Sending...
                          </>
                        ) : (
                          <>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.5 10L8.125 15.2083C8.75 15.7917 9.58333 15.7917 10.4167 15.2083L17.5 8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M10.8333 2.08333H17.5C17.9167 2.08333 18.3333 2.16667 18.75 2.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            Send Message
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
                 {responseMsg && (
                  <div style={{
                    padding: '15px 20px',
                    marginTop: '25px',
                    borderRadius: '10px',
                    backgroundColor: responseMsg.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: responseMsg.type === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${responseMsg.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {responseMsg.type === 'success' ? (
                        <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-1.1 14.58l-4.24-4.24 1.41-1.41 2.83 2.83 5.66-5.66 1.41 1.41-7.07 7.07z" fill="currentColor"/>
                      ) : (
                        <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15h-2v-2h2v2zm0-4h-2V7h2v4z" fill="currentColor"/>
                      )}
                    </svg>
                    {responseMsg.text}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Hours Section */}
      <section style={{ padding: '60px 0', background: '#1a1a2e' }}>
        <div className="themesflat-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <span style={{ 
                color: '#edb808', 
                fontSize: '14px', 
                fontWeight: '600', 
                letterSpacing: '2px',
                textTransform: 'uppercase',
                display: 'block',
                marginBottom: '15px'
              }}>
                Business Hours
              </span>
              <h2 style={{ 
                fontSize: '32px', 
                fontWeight: '700', 
                color: 'white',
                marginBottom: '30px'
              }}>
                We're Here For You
              </h2>
              <div style={{ 
                display: 'inline-flex', 
                flexDirection: 'column',
                gap: '15px',
                background: 'rgba(255,255,255,0.05)',
                padding: '30px 50px',
                borderRadius: '15px',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '60px', color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
                  <span>Monday - Sunday</span>
                  <span style={{ color: '#edb808', fontWeight: '600' }}>24/7 Available</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '60px', color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
                  <span>Phone Support</span>
                  <span style={{ color: '#edb808', fontWeight: '600' }}>Always Open</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '60px', color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
                  <span>Email Response</span>
                  <span style={{ color: '#edb808', fontWeight: '600' }}>Within 24 Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
